import Layout from '@/layout';
var aiGenerationRouter = {
  path: '/aiGeneration',
  component: Layout,
  redirect: '/aiGeneration/tasks',
  name: 'AiGeneration',
  alwaysShow: true,
  meta: {
    title: 'AI生成',
    icon: 'cpu'
  },
  children: [{
    path: 'tasks',
    component: function component() {
      return import('@/views/aiGeneration/tasks');
    },
    name: 'AiGenerationTasks',
    meta: {
      title: '生成任务'
    }
  }, {
    path: 'review',
    component: function component() {
      return import('@/views/aiGeneration/review');
    },
    name: 'AiGenerationReview',
    meta: {
      title: '视频审核'
    }
  }, {
    path: 'models',
    component: function component() {
      return import('@/views/aiGeneration/models');
    },
    name: 'AiGenerationModels',
    meta: {
      title: '模型配置'
    }
  }, {
    path: 'prices',
    component: function component() {
      return import('@/views/aiGeneration/prices');
    },
    name: 'AiGenerationPrices',
    meta: {
      title: '售价规则'
    }
  }, {
    path: 'statistics',
    component: function component() {
      return import('@/views/aiGeneration/statistics');
    },
    name: 'AiGenerationStatistics',
    meta: {
      title: '调用统计'
    }
  }]
};
export default aiGenerationRouter;